import { useIsUserInRole } from '@transport-insights/uikit';
import allReports from '../shared/report-list.json';

export const reportOrder = [
  'stateHighwaysPotholeRepairs',
  'efficiencyEffectivenessEconomy',
  'servicePerformance',
  'delivery',
  'deliveryPerformance',
  'safety',
  'amenityAndCondition',
  'temporaryTrafficManagement',
  'activityManagement',
  'dataQuality',
  'coinvestorAssurance',
  'publicTransport',
  'potholeRepairs',
  'networkAvailability',
  'networkPhysicalCharacteristics',
  'roadNetworkUse',
  'territorialActivity',
  'networkAssetManagement',
];

export const useAllowedReportsList = (rcaId) => {
  const hasDeveloperRole = useIsUserInRole('Developer');

  // If no RCA ID, return all reports
  if (!rcaId) {
    return reportOrder.filter((key) => key in allReports).reduce(
      (obj, key) => {
        obj[key] = allReports[key];
        return obj;
      },
      {},
    );
  }

  const isRegion = rcaId > 1000;
  const isNational = rcaId === 1000;

  // This is the list of reports that are allowed for all networks
  const allowedReports = [
    'roadNetworkUse',
    'temporaryTrafficManagement',
    'deliveryPerformance',
    'networkPhysicalCharacteristics',
    'delivery',
    'safety',
    'amenityAndCondition',
    'dataQuality',
  ];

  // If RCA excluding State Highways and DOC Roads
  if ((rcaId !== 81 && rcaId !== 88 && rcaId < 1000) || hasDeveloperRole) {
    allowedReports.push('networkAvailability');
    allowedReports.push('activityManagement');
  }

  // If RCA or national or region
  if ((rcaId !== 81 && rcaId !== 88) || isNational || isRegion) {
    allowedReports.push('publicTransport');
    allowedReports.push('territorialActivity');
    allowedReports.push('servicePerformance');
    allowedReports.push('coinvestorAssurance');
    allowedReports.push('efficiencyEffectivenessEconomy');
    allowedReports.push('potholeRepairs');
  }

  // If DOC Roads
  if (rcaId === 88) {
    allowedReports.push('coinvestorAssurance');
    allowedReports.push('activityManagement');
  }

  // If State Highways
  if (rcaId === 81) {
    allowedReports.push('stateHighwaysPotholeRepairs');
    allowedReports.push('territorialActivity');
    allowedReports.push('efficiencyEffectivenessEconomy');
    allowedReports.push('publicTransport');
  }

  // Filter reports list based on what is allowed
  const filteredReports = Object.keys(allReports)
    .filter((key) => allowedReports.includes(key))
    .reduce((obj, key) => {
      obj[key] = allReports[key];
      return obj;
    }, {});

  // Order reports based on reportOrder variable
  const orderedReports = reportOrder
    .filter((key) => key in filteredReports)
    .reduce((obj, key) => {
      obj[key] = filteredReports[key];
      return obj;
    }, {});

  return orderedReports;
};
